export default {
  // 获取组织列表
  GET_LIST: '/nzjxcApi/Org/GetList',
  //获取单个组织信息
  GET: '/nzjxcApi/Org/Get',
  //保存组织(含新建、更新)
  SAVE: '/nzjxcApi/Org/Save',
  //更新状态
  SET_STATUS: '/nzjxcApi/Org/SetStatus',
  //保存logo设置
  SAVE_LOGO: '/nzjxcApi/OrgExt/Save',
  //获取单个组织logo信息
  GET_LOGO: '/nzjxcApi/OrgExt/Get',
  //获取域名获取组织个性化配置
  GET_LOGO_EXT: '/nzjxcApi/OrgExt/getOrgExt'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/org/index.js